import { LoadingButton } from "@mui/lab";
import { Button, Grid, Stack, TextField } from "@mui/material";
import { FormTextField } from "components/atoms";
import { CommonModal } from "components/molecules";
import { FormikHelpers, FormikProvider, useFormik } from "formik";
import { isEmpty } from "lodash";
import { IChangePasswordRequest } from "model";
import { IdentityActions, PrintActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { I18nTranslator, translations } from "utils/i18n";
import * as yup from "yup";

const validateSchema = yup.object().shape({
  password: yup.string().required(translations.yupError.required),
  newPassword: yup.string().required(translations.yupError.required),
  confirmNewPassword: yup
    .string()
    .required(translations.yupError.required)
    .oneOf(
      [yup.ref("newPassword"), null],
      I18nTranslator(translations.yupError.passwordNotMatch)
    ),
});

const ChangePasswordModal = (props: { open: boolean; onClose(): void }) => {
  const { open, onClose } = props;
  const dispatch = useAppDispatch();
  const formik = useFormik<IChangePasswordRequest>({
    initialValues: {
      password: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    validationSchema: validateSchema,
    onSubmit: (
      values: IChangePasswordRequest,
      { validateForm }: FormikHelpers<IChangePasswordRequest>
    ) => {
      validateForm().then(() => {
        _changePassword(values);
      });
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };
  const renderFooter = () => {
    return (
      <Footer
        onSubmit={formik.submitForm}
        disableConfirm={
          isEmpty(formik.values.password) ||
          isEmpty(formik.values.newPassword) ||
          isEmpty(formik.values.confirmNewPassword)
        }
        onClose={handleClose}
      />
    );
  };

  const _changePassword = (request: IChangePasswordRequest) => {
    dispatch(IdentityActions.changePassword.request(request));
  };

  return (
    <CommonModal
      title={I18nTranslator(translations.masterData.changePassword)}
      open={open}
      FooterComponent={renderFooter()}
      handleClose={handleClose}
    >
      <FormikProvider value={formik}>
        <form noValidate onSubmit={formik.handleSubmit}>
          <Grid container xs={12} rowSpacing={2}>
            <Grid xs={12} container item>
              <FormTextField
                label={I18nTranslator(translations.oldPassword)}
                placeholder={I18nTranslator(translations.placeholder.password)}
                id="password"
                type={"password"}
              />
            </Grid>
            <Grid xs={12} container item>
              <FormTextField
                label={I18nTranslator(translations.newPassword)}
                placeholder={I18nTranslator(
                  translations.placeholder.newPassword
                )}
                id="newPassword"
                type={"password"}
              />
            </Grid>
            <Grid xs={12} container item>
              <FormTextField
                label={I18nTranslator(translations.confirmNewPassword)}
                placeholder={I18nTranslator(
                  translations.placeholder.confirmNewPassword
                )}
                id="confirmNewPassword"
                type={"password"}
              />
            </Grid>
          </Grid>
        </form>
      </FormikProvider>
    </CommonModal>
  );
};

const Footer = (props: {
  disableConfirm: boolean;
  onClose(): void;
  onSubmit(): void;
}) => {
  const { disableConfirm, onClose, onSubmit } = props;
  const action = useAppSelector((state) => state.IdentityReducer.action);
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
      <Button onClick={onClose}>
        {I18nTranslator(translations.button.close)}
      </Button>
      <LoadingButton
        loading={action.includes(IdentityActions.changePassword.requestName)}
        disabled={disableConfirm}
        variant="contained"
        onClick={onSubmit}
      >
        {I18nTranslator(translations.button.changePassword)}
      </LoadingButton>
    </Stack>
  );
};
export default ChangePasswordModal;
